import { render, staticRenderFns } from "./WatDetails.vue?vue&type=template&id=092cf648&"
import script from "./WatDetails.vue?vue&type=script&lang=js&"
export * from "./WatDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports